<template>
  <div class='navbar'>
    <el-dropdown :hide-on-click='false' trigger='click' @command='handleCommand'>
      <span><i class='icon-person-navbar icon'></i></span>
      <el-dropdown-menu slot='dropdown'>
        <el-dropdown-item command='passward'>修改密码</el-dropdown-item>
        <el-dropdown-item command='exit' divided>退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog v-if='show_pwd_modal' :visible.sync='show_pwd_modal' title='修改密码' style='width: auto'>
      <el-form :inline='false' :model='pwdForm' :rules='rules' ref='pwdForm' label-position='left'>
        <el-form-item label='请输入旧密码' prop='MApasswordOld'>
          <el-input v-model='pwdForm.MApasswordOld' type='password' placeholder=''></el-input>
        </el-form-item>
        <el-form-item label='请输入新密码' prop='MApasswordNew'>
          <el-input v-model='pwdForm.MApasswordNew' type='password' placeholder=''></el-input>
        </el-form-item>
        <el-form-item label='请确认新密码' prop='MApasswordRepeat'>
          <el-input v-model='pwdForm.MApasswordRepeat' type='password'
                    placeholder=''></el-input>
        </el-form-item>
        <el-button @click="pwdSubmit('pwdForm')">确认修改</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import store from '../../../vuex/index.js';
import api from '../../../api/api';
import { MessageBox } from 'element-ui';
import axios from 'axios';

export default {

  components: {},
  computed: {},
  data() {
    return {
      isActive: false,
      show_pwd_modal: false,
      pwdForm: {
        MApasswordOld: '',
        MApasswordNew: '',
        MApasswordRepeat: ''
      },
      rules: {
        MApasswordOld: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        MApasswordNew: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        MApasswordRepeat: [
          { required: true, message: '请确认新密码', trigger: 'blur' }
        ]
      }

    };
  },
  methods: {
    sidebar(v) {
      store.state.isCollapse = !store.state.isCollapse;
      let main = document.getElementsByClassName('main-container')[0];
      if (store.state.isCollapse) {
        main.style.marginLeft = '0.63rem';
        this.isActive = true;
      } else {
        main.style.marginLeft = '1.8rem';
        this.isActive = false;
      }

    },
    hideModal() {
      this.show_pwd_modal = false;
    },
    pwdSubmit(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            password_old: this.pwdForm.MApasswordOld,
            password_new: this.pwdForm.MApasswordNew,
            password_repeat: this.pwdForm.MApasswordRepeat,
          }
          axios.post(api.changePwd, params, {
            headers:{
              token: localStorage.getItem('token')
            }
          }).then(res => {
            if (res.data.status == 200) {
              this.$message.success('修改成功,请重新登录')
              localStorage.clear()
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message);
            }
          }, res => {
            this.$message.error(res.data.message);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    handleCommand(command) {
      if (command == 'passward') {
        this.show_pwd_modal = true;
      }
      if (command == 'exit') {
        localStorage.clear();
        window.location.reload();
      }
    },
    modalClick(e) {
      e.stopPropagation();
      return false;
    }
  }
};
</script>

<style rel='stylesheet/less' lang='less' scoped>
@import "../../../common/css/_variate";
@import "../../../common/css/modal";

.navbar {
  /*height: 0.5rem;*/
  border: 1px solid @borderColor;
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem;
  background-color: #5A738A;

  .m-search-box {
    width: 1.80rem;
    height: 0.27rem;
    line-height: 0.27rem;
    font-size: 0.12rem;
    border: 1px solid @mainColor;
    position: relative;
    border-radius: 5px;

    .icon-search {
      width: 0.18rem;
      height: 0.18rem;
      position: absolute;
      top: 0.05rem;
      left: 0.1rem;
      /*background: url("../../../common/images/icon-search.png");*/
      background-size: 100% 100%;
    }

    input {
      border: none;
      height: 0.27rem;
      width: 1.4rem;
      padding-left: 0.4rem;

      &:focus {
        border: none;
        outline-offset: 0;
        outline-color: transparent;
      }
    }
  }

  .icon {
    display: inline-block;
    width: 0.3rem;
    height: 0.3rem;
  }

  .icon-person-navbar {
    background: url("../../../common/images/icon-person-navbar.png");
    background-size: 100% 100%;
    margin: 0 0.05rem;
  }

  .icon-message {
    /*background: url("../../../common/images/icon-message.png");*/
    background-size: 100% 100%;
    margin: 0 0.2rem;
  }

  .navbar-sidebar {
    display: inline-block;
    width: 0.4rem;
    height: 0.4rem;
    cursor: pointer;
  }
}

.hamburger.is-active {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.hamburger {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

</style>



// WEBPACK FOOTER //
// src/views/layout/component/Navbar.vue